module.exports = __webpack_public_path__ + "static/media/long_cymbal_01.7a357bf3.wav";